var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "record-appraisal-list" }, [
    _c(
      "ul",
      { staticClass: "list-unstyled mb-0" },
      _vm._l(_vm.appraisals, function (appraisal) {
        return _c(
          "li",
          { key: appraisal.id, staticClass: "record-appraisal-list-item mb-2" },
          [
            _c(
              "a",
              { attrs: { href: _vm.getAppraisalDetailUrl(appraisal.id) } },
              [
                _vm._v(
                  "\n                Forderung #" +
                    _vm._s(appraisal.attributes.appraisalNumber) +
                    "\n            "
                ),
              ]
            ),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }